import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import {
  catchError,
  finalize,
  map,
  Observable,
  switchMap,
  throwError,
} from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../core/services/cal-services/auth.service';
import { LoaderService } from '../core/services/loader.service';
import { CalService } from '../auth/cal.service';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const calService = inject(CalService);
  const loaderService = inject(LoaderService);
  const addToken = (req: HttpRequest<any>): HttpRequest<any> => {
    const token = authService.getToken();
    if (token) {
      return req.clone({
        setHeaders: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return req;
  };

  const handle401Error = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    return calService.getUserImpersonationToken().pipe(
      switchMap(() => {
        return next(addToken(req));
      })
    );
  };

  loaderService.showLoader();
  return next(addToken(req)).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return handle401Error(req, next);
      } else if (error.status === 403) {
        if (
          showOkDialog('You do not have permission to access this resource.')
        ) {
          window.location.href = '/';
        }
        return throwError(() => error);
      } else if (error.status === 423) {
        sessionStorage.setItem('userIsActive', 'false');
        return throwError(() => error);
      } else {
        return throwError(() => error);
      }
    }),
    finalize(() => {
      loaderService.hideLoader();
    })
  );
};

function showOkDialog(message: string): boolean {
  alert(message);
  return true;
}
